"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// styles
require("./styles/search.scss");
var controllers_1 = require("./controllers");
var services_1 = require("./services");
var routes_1 = __importDefault(require("./config/routes"));
var directives_1 = require("./directives");
/**
 * @ngdoc module
 * @module rinca.apps.searh
 * @name rinca.apps.searh
 * @packageName rinca.apps
 * @description A module that includes the searh component.
 */
angular.module('rinca.apps.search', ['ui.router'])
    .controller('SearchController', controllers_1.SearchController)
    .directive('productSearch', directives_1.ProductSearchDirective)
    .service('_search', services_1.SearchService)
    .config(routes_1.default);



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/search/index.ts
// module id = 464
// module chunks = 0